import PrismicLink from '@components/PrismicLink';
import { IFooterBlocLinks } from '@context/LayoutContext/types';
import { useMediaQuery } from '@monofront/business/hooks';
import Collapse from '@monofront/design-system/visuals/Icons/Old/Collapse';
import Expand from '@monofront/design-system/visuals/Icons/Old/Expand';
import Button from '@monofront/design-system/components/Button';
import { useState } from 'react';

const BlocLinks = ({ slice }: { slice: IFooterBlocLinks }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery(800);

  if (!slice || !slice.primary || !slice.items) {
    return null;
  }

  const { primary, items } = slice;

  return (
    <>
      <div className="bloc-links">
        <h3>
          <Button
            disabled={!isMobile}
            variant="clear"
            className="accent-title"
            onClick={() => setIsOpen(!isOpen)}
            ariaExpanded={isMobile ? isOpen : true}
            ariaControls={`bloc-links-${primary.sectionId}`}
            dataTestId="BlocLinks-Button-1"
          >
            {primary.listTitle}
            {isOpen ? (
              <Collapse className="mobile-only" aria-hidden />
            ) : (
              <Expand className="mobile-only" aria-hidden />
            )}
          </Button>
        </h3>
        <ul
          id={`bloc-links-${primary.sectionId}`}
          className={`${isOpen ? '' : 'desktop-only'}`}
        >
          {items.map(({ link, name, trackingidFooterLink }, index) => (
            <li key={index}>
              {link ? (
                <PrismicLink
                  link={link}
                  trackingId={trackingidFooterLink || undefined}
                >
                  {name}
                </PrismicLink>
              ) : (
                name
              )}
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .bloc-links h3 {
          margin-bottom: var(--space-5);
        }

        .bloc-links h3 :global(button[disabled]) {
          cursor: default;
        }

        ul > li {
          margin-bottom: var(--space-4);
        }

        ul > li > :global(a:hover) {
          text-decoration: underline;
        }

        @media (max-width: 800px) {
          .bloc-links h3 {
            margin-bottom: 0;
          }
          .bloc-links h3 :global(button) {
            display: inline-flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          }
          .bloc-links ul {
            margin-top: var(--space-4);
          }
        }
      `}</style>
    </>
  );
};

export default BlocLinks;
